<template>
  <div class="message-box dialog-mask">
    <div class="dialog-content">
      <header>オプション機能</header>
      <div class="dialog-body">
        <div>
          <hr />
          <h2>◉ 執筆モードを切り替える</h2>
          <p>ダークモードなどに執筆モードを切り替えて、利用することができます。</p>
          <select :value="theme" @change="onSelectColorTheme($event)">
            <option value="" disabled>カラーを選択</option>
            <option value="default">ライトモード</option>
            <option value="dark">ダークモード</option>
            <option value="sepia">セピアモード</option>
            <option value="blackboard">黒板モード</option>
            <option value="bold">太字モード</option>
          </select>
          <hr />
        </div>
        <div>
          <h2>{{ $t("manuscriptEditorMenuDialog.editorStyleSettingsHeading") }}</h2>
          <p>{{ $t("manuscriptEditorMenuDialog.editorStyleSettingsDescription") }}</p>
          <button type="button" class="dialog-body-button" @click="openEditorStyleSettings">{{ $t("manuscriptEditorMenuDialog.openSettings") }}</button>
          <hr />
        </div>
        <button class="dialog-body-close" @click="$close(false)">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Dialog } from "@/lib/utils";
import EditorStyleSettingsModal from "@/components/ui/EditorStyleSettingsModal.vue";

export default Vue.extend({
  methods: {
    cancel() {
      this.$close(false);
    },
    onSelectColorTheme(event) {
      this.$store.dispatch("manuscriptModule/selectTheme", event.target.value);
    },
    openEditorStyleSettings() {
      this.$close(false);
      const dialog = new Dialog(EditorStyleSettingsModal);
      dialog.show({ source: "writing" });
    },
  },
  computed: {
    theme() {
      return this.$store.getters["manuscriptModule/theme"];
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";
header {
  font-weight: bold;
  font-size: large;
  margin: 15px auto;
}

.button-area {
  margin: 10px auto;
  float: right;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-body {
  font-size: larger;
}

.dialog-mask {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.33);
}

.dialog-content {
  margin: 0 10px;
  padding: 10px 15px;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-md);
  color: var(--color-text-normal);
}
.dialog-body h2 {
  font-size: 16px;
  padding: 0;
  margin: 15px 0 10px 0;
}
.dialog-body p {
  font-size: 14px;
  padding: 0;
  margin: 5px 0;
  color: var(--color-text-low);
}
.dialog-body select {
  border: solid 1px var(--color-border);
  padding: 5px 10px;
  margin: 5px 0;
  margin-bottom: 15px;
  font-size: 14px;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
}
.dialog-body button {
  display: block;
  border: solid 1px var(--color-border);
  border-radius: 5px;
  padding: 10px;
  margin: 5px 0;
  margin-bottom: 20px;
  font-size: 14px;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
}
.dialog-body .dialog-body-button {
  position: relative;
  display: block;
  border: solid 1px var(--color-border);
  border-radius: 5px;
  padding: 8px 16px;
  margin: 5px 0 15px 0;
  font-size: 14px;
  background-color: var(--color-surface-muted);
  color: var(--color-text-normal);
  cursor: pointer;

  @include hover-overlay;
}

.dialog-body .dialog-body-close {
  position: relative;
  display: block;
  width: 100%;
  border: none;
  background-color: var(--color-primary);
  color: var(--color-text-on-fixed-bg);
  padding: 10px auto;
  margin-top: 15px;
  margin-bottom: 10px;
  cursor: pointer;

  @include hover-overlay;
}
</style>
